import * as requests from "../coraWebComponents/utils/requests";
import { strToDate } from '../coraWebComponents/utils/convert';
import urls from "../constants/Urls";

const buildZiadost = (id = "") => {
  return `${urls.ZIADOST}/${id}`;
};

const handleData = (res) => {
  res.Data.Items = res.Data.Items.map(item => {
    return {
      ...item,
      D_VYBAVENIA: strToDate(item.D_VYBAVENIA),
      D_ZMENY: strToDate(item.D_ZMENY),
      D_POD: strToDate(item.D_POD),
      DetailStavby: {
        ...item.DetailStavby,
        D_POZADOVANE_VYBAVENIE: strToDate(item.DetailStavby.D_POZADOVANE_VYBAVENIE),
        D_ZAC_STAVBY: strToDate(item.DetailStavby.D_ZAC_STAVBY),
        D_UKONC_STAVBY: strToDate(item.DetailStavby.D_UKONC_STAVBY),
      },
      Vyjadrenie: item.Vyjadrenie.map(x => { return { ...x, D_VYJADRENIE: strToDate(x.D_VYJADRENIE) }; })
    }
  });

  return res;
};

export const podatZiadost = async (data, file) => {
  const url = buildZiadost();
  try {
    let res = await requests.postWithFile(url + "podat", data, file);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getAllListZiadost = async (filter, sort, page) => {
  const url = buildZiadost();
  try {
    let res = await requests.getList(url + "vsetky", filter, sort, page);
    return handleData(res);
  } catch (error) {
    throw error;
  }
};

export const getMyListZiadost = async (filter, sort, page) => {
  const url = buildZiadost();
  try {
    let res = await requests.getList(url + "moje", filter, sort, page);
    return handleData(res);
  } catch (error) {
    throw error;
  }
};

export const vybavuje = async (id) => {
  const url = buildZiadost();
  try {
    let res = await requests.put(url + "vybavuje/" + id);
    return res;
  } catch (error) {
    throw error;
  }
};

export const zrusRezervaciu = async (id) => {
  const url = buildZiadost();
  try {
    let res = await requests.put(url + "zrusRezervaciu/" + id);
    return res;
  } catch (error) {
    throw error;
  }
};